import Vue from 'vue'

import Vuex from 'vuex'
Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    index: 0,
    baseuel: 'https://www.sigoran.com/'
    //  baseuel: 'http://test-home.chpigeon.com/'
  },
  actions: {
    SET_INDEX: (state, index) => {
      state.index = index
    },

  },

  getters: {
    index: state => {
      return state.index
    },
    baseurl: state => {
      return state.baseuel
    },


  },
  mutations: {
    changindex(state, index) {
      state.index = index
    },

  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js